// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__IQpna","cell":"ColumnAccessor_cell__eAp7_","firstCellAccent":"ColumnAccessor_firstCellAccent__1lCnZ"};